<app-grid-modal
  stateKey="UserPrintersEdit"
  [id]="id()"
  [columnDefs]="columnDefs"
  [fields]="fields"
  [formModel]="model()"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  (save)="save()"
></app-grid-modal>
